import { useState } from "react";
import { useRouter } from "next/router";
import { IoIosArrowDown } from "react-icons/io";

const LanguageSwitcher = ({ locale }) => {
  const router = useRouter();

  const languageMap = {
    en: "العربية",
    ar: "English",
  };

  const targetLocale = locale === "ar" ? "en" : "ar";

  const changeLanguage = () => {
    const { pathname, asPath, query } = router;
    router.push({ pathname, query }, asPath, { locale: targetLocale });
  };

  return (
    <button
      onClick={changeLanguage}
      className="w-max rounded-[50px] bg-[#e72c46] text-white text-[12px] xl:text-[14px] font-medium py-1.5 px-3 cursor-pointer hover:bg-white hover:text-black transition duration-300 ease-in-out"
    >
      {languageMap[locale]}
    </button>
  );
};

export default LanguageSwitcher;
